/* Recherche DHEM sur Typesense : overlay plein écran déclenché par l'icône de
   recherche du header (court-circuite Searchanise + le modal Dawn).
   Autocomplete groupé : catégories + marques + produits, surlignage, clavier. */
(function () {
  "use strict";
  var C = window.TS_KEYS;
  if (!C) return;
  var base = C.protocol + "://" + C.host + ":" + C.port;
  var eur = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });

  function esc(s) { return (s == null ? "" : String(s)).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function hl(text, term) {
    var t = esc(text);
    if (!term) return t;
    try {
      var re = new RegExp("(" + term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")", "ig");
      return t.replace(re, "<strong>$1</strong>");
    } catch (e) { return t; }
  }

  var overlay, oInput, oResults, oClear, built = false, tmr;

  function build() {
    overlay = document.createElement("div");
    overlay.className = "ts-so";
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="ts-so__bar">' +
        '<button type="button" class="ts-so__back" aria-label="Fermer">' +
          '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M15 6l-6 6 6 6"/></svg></button>' +
        '<div class="ts-so__field">' +
          '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="#9a9a9a" stroke-width="1.6"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>' +
          '<input type="search" placeholder="Rechercher un produit, une marque…" autocomplete="off" enterkeyhint="search">' +
          '<button type="button" class="ts-so__clear" aria-label="Effacer" hidden>' +
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        "</div></div>" +
      '<div class="ts-so__results"></div>';
    document.body.appendChild(overlay);
    oInput = overlay.querySelector("input");
    oResults = overlay.querySelector(".ts-so__results");
    oClear = overlay.querySelector(".ts-so__clear");
    overlay.querySelector(".ts-so__back").addEventListener("click", close);
    oClear.addEventListener("click", function () { oInput.value = ""; oClear.hidden = true; oResults.innerHTML = ""; oInput.focus(); });
    // Produit cliqué depuis l'overlay : on empile une page /search dans l'historique
    // pour que le bouton Retour du navigateur ramène sur les résultats de recherche.
    oResults.addEventListener("click", function (e) {
      var item = e.target.closest(".ts-ac__item");
      if (!item) return;
      var term = oInput.value.trim();
      if (!term) return;
      e.preventDefault();
      try { history.pushState({}, "", "/search?q=" + encodeURIComponent(term) + "&type=product"); } catch (_) {}
      window.location.href = item.getAttribute("href");
    });
    oInput.addEventListener("input", function () {
      var term = oInput.value.trim();
      oClear.hidden = !term;
      clearTimeout(tmr);
      if (term.length < 2) { oResults.innerHTML = ""; return; }
      tmr = setTimeout(function () { query(term); }, 160);
    });
    oInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        var term = oInput.value.trim();
        if (term) window.location.href = "/search?q=" + encodeURIComponent(term) + "&type=product";
      } else nav(e);
    });
    built = true;
  }

  function open(e, prefill) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (!built) build();
    overlay.hidden = false;
    document.body.style.overflow = "hidden";
    if (prefill != null) { oInput.value = prefill; oClear.hidden = !prefill; if (prefill && prefill.length >= 2) query(prefill); }
    requestAnimationFrame(function () { overlay.classList.add("is-open"); oInput.focus(); });
  }
  function close() {
    if (!overlay) return;
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function () { overlay.hidden = true; }, 220);
  }

  function nav(e) {
    var items = Array.prototype.slice.call(oResults.querySelectorAll("a"));
    if (!items.length) return;
    var cur = oResults.querySelector("a.is-active"), idx = items.indexOf(cur);
    if (e.key === "ArrowDown") { e.preventDefault(); idx = (idx + 1) % items.length; }
    else if (e.key === "ArrowUp") { e.preventDefault(); idx = (idx - 1 + items.length) % items.length; }
    else return;
    items.forEach(function (a) { a.classList.remove("is-active"); });
    items[idx].classList.add("is-active");
    items[idx].scrollIntoView({ block: "nearest" });
  }

  function facetItems(result, field) {
    var fc = ((result || {}).facet_counts || [])[0];
    if (!fc) return [];
    return (fc.counts || []).map(function (c) { return { value: c.value, count: c.count, field: field }; });
  }

  function query(term) {
    var body = { searches: [
      { collection: C.collection, q: term, query_by: "title,marque,sku,description",
        query_by_weights: "4,3,4,1", exclude_fields: "description", per_page: 8 },
      { collection: C.collection, q: "*", query_by: "title", facet_by: "sous_categorie",
        facet_query: "sous_categorie:" + term, max_facet_values: 4, per_page: 0 },
      { collection: C.collection, q: "*", query_by: "title", facet_by: "categorie",
        facet_query: "categorie:" + term, max_facet_values: 3, per_page: 0 },
      { collection: C.collection, q: "*", query_by: "title", facet_by: "marque",
        facet_query: "marque:" + term, max_facet_values: 4, per_page: 0 }
    ] };
    fetch(base + "/multi_search", { method: "POST",
      headers: { "X-TYPESENSE-API-KEY": C.apiKey, "Content-Type": "application/json" },
      body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) { render(term, res.results || []); })
      .catch(function () {});
  }

  function render(term, r) {
    var products = ((r[0] || {}).hits || []).map(function (h) { return h.document; });
    var found = (r[0] || {}).found || 0;
    var cats = facetItems(r[1], "sous_categorie").concat(facetItems(r[2], "categorie")).slice(0, 4);
    var marques = facetItems(r[3], "marque").slice(0, 4);
    if (!cats.length && !marques.length && !products.length) {
      oResults.innerHTML = '<div class="ts-ac__empty">Aucun résultat pour « ' + esc(term) + ' ». Essayez avec moins de mots.</div>';
      return;
    }
    var html = "";
    if (cats.length) {
      html += '<div class="ts-ac__grp">Catégories</div>' + cats.map(function (c) {
        return '<a class="ts-ac__row" href="/search?' + c.field + "=" + encodeURIComponent(c.value) + '">' +
          "<span>" + hl(c.value, term) + '</span><span class="ts-ac__n">' + c.count + "</span></a>";
      }).join("");
    }
    if (marques.length) {
      html += '<div class="ts-ac__grp">Marques</div>' + marques.map(function (m) {
        return '<a class="ts-ac__row" href="/search?marque=' + encodeURIComponent(m.value) + '">' +
          "<span>" + hl(m.value, term) + '</span><span class="ts-ac__n">' + m.count + "</span></a>";
      }).join("");
    }
    if (products.length) {
      html += '<div class="ts-ac__grp">Produits</div>' + products.map(function (d) {
        var img = d.image ? d.image.replace(/(\.[a-z]+)(\?|$)/i, "_100x$1$2") : "";
        return '<a class="ts-ac__item" href="/products/' + esc(d.handle) + '">' +
          '<span class="ts-ac__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") + "</span>" +
          '<span class="ts-ac__txt"><span class="ts-ac__brand">' + esc(d.marque || "") + "</span>" +
          '<span class="ts-ac__title">' + hl(d.title || "", term) + "</span></span>" +
          '<span class="ts-ac__price">' + eur.format(d.prix || 0) + "</span></a>";
      }).join("");
    }
    html += '<a class="ts-ac__all" href="/search?q=' + encodeURIComponent(term) + '&type=product">Voir les ' + found + " résultats</a>";
    oResults.innerHTML = html;
  }

  // Intercepte le clic sur l'icône de recherche (capture -> bloque Searchanise/Dawn).
  document.addEventListener("click", function (e) {
    var trig = e.target.closest(".header__icon--search, .header__search summary, .header__search .modal__toggle");
    if (trig) { open(e); return; }
    // Barre de recherche de la page résultats : ouvre le même overlay (pré-rempli)
    var sf = e.target.closest(".ts-searchform");
    if (sf) { var f = sf.querySelector("input[name=q]"); open(e, f ? f.value.trim() : ""); }
  }, true);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay && !overlay.hidden) close();
  });
})();
